import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, isRef as _isRef, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b15f0d5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-block-wrap" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "贷款人信息")
], -1))
const _hoisted_3 = { class: "block-main" }
const _hoisted_4 = { class: "van-hairline--bottom" }
const _hoisted_5 = { class: "van-hairline--bottom" }
const _hoisted_6 = { class: "van-hairline--bottom" }
const _hoisted_7 = { class: "van-hairline--bottom" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "* 根据银行政策要求贷款申请人须与当前账号实名认证为同一人；"),
  /*#__PURE__*/_createElementVNode("div", null, "* 当前页面填写信息仅作新农贷申请使用；")
], -1))
const _hoisted_9 = { class: "form-block-wrap" }
const _hoisted_10 = { class: "title-wrap" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "套装选配", -1))
const _hoisted_12 = { class: "block-main" }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "form-block-wrap" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "贷款申请信息")
], -1))
const _hoisted_16 = { class: "block-main" }
const _hoisted_17 = { class: "van-hairline--bottom" }
const _hoisted_18 = { class: "van-hairline--bottom" }
const _hoisted_19 = { class: "van-hairline--bottom" }
const _hoisted_20 = { class: "van-hairline--bottom" }
const _hoisted_21 = {
  key: 0,
  class: "van-hairline--bottom"
}
const _hoisted_22 = { class: "van-hairline--bottom" }
const _hoisted_23 = { class: "van-hairline--bottom" }
const _hoisted_24 = { class: "text" }
const _hoisted_25 = ["onClick"]

import { useStore } from 'vuex'
import { v4 as uuidv4 } from 'uuid'
import { useRouter } from 'vue-router'
import { getThousandMoney } from '@/utils/index'
import { commonErrorHandle } from '@/utils/error-handle'
import { computed, onActivated, Ref, ref, watch } from 'vue'
import { requestSendVerifyCode, requestAgriculturaLoanApply } from '@/apis/agricultura-loan'
import {
  times,
  plus,
  minus,
  getSha256ValueSync,
  showToastLoading,
  clearToast,
  showConfirmModal,
  showToastSuccess,
  showNormalToast,
} from '@/utils/tools'
import { Form, Field, FieldRule, RadioGroup, Radio, Icon } from 'vant'
import {
  AgriculturalLoanDeviceListRouteName,
  AgriculturalLoanAddressSelectRouteName,
  AgriculturalLoanPackageSelectionRouteName,
  AgriculturalLoanAgreementRouteName,
  AgriculturalLoanPowerOfAttorneyRouteName,
} from '@/defination/constant'
import {
  StandardProduct,
  OptionalAccessoriesItem,
  CombinationInfo,
  ApplyFormPackageSelectionsItem,
  MyEquipmentItem,
  AgriculturalLoanApplyRequest,
  AgriculturalLoanApplyBaseParams,
} from '@/types/agricultura-loan'
import AppHost from '@/utils/app'
import { useArgiculturaLoanKeepAliveControll } from '@/compositions/agricultura-loan/index'
import {
  SelectedAddressInfoStorage,
  ConfirmUsePackageInfoStorage,
  ConfirmBindDeviceInfoStorage,
  CurrentPackageSelectionInfoStorage,
  PackageSelectionCodeMapStorage,
  VerifySmsCodeStartTime,
} from '@/storage/agricultura-loan'
import AppHeader from '@/components/Header.vue'
import LimitTimeSelect from './components/limit-time-select.vue'
import DistributorSelect from './components/distributor-select.vue'
import PackageProductInfo from './components/package-product-info.vue'
import DistributorVerifyCode from './components/distributor-verify-code.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'

interface FormAddressItem {
  text: string
  value: string[]
  detail: string
}
interface LastSmsCodeInfoType {
  time: number
  client_guid: string
  message_guid: string
}
interface FormDataType {
  name: string
  id_card: string
  permanentAddress: FormAddressItem
  businessAddress: FormAddressItem
  client_guid: string
  clientText: string
  apply_deadline: string
  isPayedOffDownPayment: string
  payment_amount: string
  family_annual_income: string
  apply_loan_amount: string
  code: string
  packageInfo: Array<
    ApplyFormPackageSelectionsItem & {
      showWarning?: boolean
      price: number
    }
  >
}

import { defineComponent } from 'vue'
import { AgriculturalLoanApplyFormRouteName } from '@/defination/constant'
import { BooleanObject } from '@/types/public'

const __default__ = defineComponent({
  name: AgriculturalLoanApplyFormRouteName,
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const cacheDataKey = 'localApplyFormCacheKey'
let caacheFormValue: any = null
try {
  caacheFormValue = JSON.parse(localStorage.getItem(cacheDataKey))
} catch (error) {
  console.log('caacheFormValue', caacheFormValue)
}

const canUseCache = location.origin.indexOf('localhost') !== -1

const formVm = ref()
const $router = useRouter()
const { addApplyFormKeepAlive, removeApplyFormAlive, removeContractListKeepAlive } =
  useArgiculturaLoanKeepAliveControll()
const limitTimePopupVisible = ref(false)
const distributorSelectPopupVisible = ref(false)
const isAgreed = ref(false)
const verifyCodeVisible = ref(false)
const store = useStore()
const formData: Ref<FormDataType> = ref(
  canUseCache && caacheFormValue
    ? caacheFormValue
    : {
        name: '',
        id_card: '',
        permanentAddress: {
          text: '',
          value: [],
          detail: '',
        },
        businessAddress: {
          text: '',
          value: [],
          detail: '',
        },
        client_guid: '',
        clientText: '',
        apply_deadline: '',
        isPayedOffDownPayment: '',
        payment_amount: '',
        family_annual_income: '',
        apply_loan_amount: '0',
        packageInfo: [],
        code: '',
      }
)
// 文案配置
const nameLabel = '贷款人姓名'
const userIdCardLabel = '贷款人身份证号码'
const permanentAddressLabel = '常住地址'
const businessAddressLabel = '经营地址'
const applyPriceLabel = '申请贷款金额'
const applyLimitTimeLabel = '申请期限'
const buyProductPriceLabel = '购机金额'
const payedOffDownPaymentLabel = '是否已支付首付款'
const payedOffDownPaymentPriceLabel = '已支付首付款金额'
const annualHouseholdIncomeLabel = '家庭年收入'
const jifeiDistributorLabel = '极飞分销商'
const contractMachineBinding = '合约机绑定'
const payedoffDownUnPayTips = '需先支付购机金额20%的首付款才能申请贷款'
const payedoffDownProcessTips = '需至少支付购机金额的20%'

watch(formData.value, () => {
  const key = cacheDataKey
  localStorage.setItem(cacheDataKey, JSON.stringify(formData.value))
})
// 申请人姓名校验
const fomrNameRules: FieldRule[] = [
  { required: true, message: `请输入${nameLabel}` },
  {
    required: true,
    trigger: 'onSubmit',
    validator: (value) => {
      // 检验是否和实名制姓名一致
      if (store?.state?.userInfo?.realName !== value) {
        console.log('真实姓名', store?.state?.userInfo?.realName, value)
        return '与当前账号实名验证的姓名不一致'
      }
      return true
    },
  },
]
// 申请人身份证号码校验
const fomrIdCardRules: FieldRule[] = [
  { required: true, message: `请填写${userIdCardLabel}` },
  {
    required: true,
    trigger: 'onSubmit',
    validator: (value) => {
      // 检验是否和实名制姓名一致
      const sha256Value = getSha256ValueSync(value)
      if (store?.state?.userInfo?.idcard !== sha256Value) {
        return '与当前账号实名验证的身份证号不一致'
      }
      return true
    },
  },
]
// 常驻地址
const formPermanentAddressRules: FieldRule[] = [
  { required: true, message: `请填写${permanentAddressLabel}` },
]
// 经营地址
const formBusinessAddressRules: FieldRule[] = [
  { required: true, message: `请填写${businessAddressLabel}` },
]
// 申请期限
const fomrApplyLimitTimeRules: FieldRule[] = [
  { required: true, message: `请选择${applyLimitTimeLabel}` },
]
// 是否已支付首付款
const fomrPayedOffDownPaymentRules: FieldRule[] = [
  { required: true, message: `请选择${payedOffDownPaymentLabel}` },
  {
    required: true,
    trigger: 'onSubmit',
    validator: (value) => {
      // 检验是否和实名制姓名一致
      if (Number(value) === 1) {
        return payedoffDownUnPayTips
      }
      return true
    },
  },
]
// 已支付首付款校验
const formPayedOffDownPaymentPriceRules: FieldRule[] = [
  { required: true, message: `请输入${payedOffDownPaymentPriceLabel}` },
  {
    required: true,
    validator: (value) => {
      value = Number(getPriceBeforeFormatValue(value))
      if (value < times(buyProductTotalPrice.value, 0.2)) {
        return payedoffDownProcessTips
      }
      if (value > buyProductTotalPrice.value) {
        return '首付款不能超过购机金额'
      }
      return true
    },
  },
]
// 家庭年收入
const formAnnualHouseholdIncomePriceRules: FieldRule[] = [
  { required: true, message: `请输入${annualHouseholdIncomeLabel}` },
]
// 购机总金额
const buyProductTotalPrice = computed(() => {
  const packageInfo = formData.value?.packageInfo
  if (!packageInfo) {
    return 0
  }
  const totalValue = packageInfo.reduce((sum, item) => {
    const packageItemTotal = times(item.price, item.num)
    return plus(sum, packageItemTotal)
  }, 0)
  return totalValue
})
// 购机总金额格式化
const buyProductTotalPriceFormat = computed(() => {
  return `${getThousandMoney(buyProductTotalPrice.value)}`
})
// 申请货款总金额
const applyLoanAmount = computed(() => {
  let value = 0
  if (buyProductTotalPrice.value && formData.value.payment_amount) {
    value = minus(
      buyProductTotalPrice.value,
      Number(getPriceBeforeFormatValue(formData.value.payment_amount))
    )
  }
  // 最小值应该为0
  value = Math.max(value, 0)
  // 最大值不超过100000
  value = Math.min(value, 100000)
  // 返回值格式化后千分位
  return `${getThousandMoney(value)}`
})
function priceBlurFormatterHandle(key: 'payment_amount' | 'family_annual_income') {
  const value = formData.value[key].replace(/[^0-9.]/g, '')
  formData.value[key] = priceFormatter(value)
}
function priceFocusFormatterHandle(key: 'payment_amount' | 'family_annual_income') {
  const value = formData.value[key]
  formData.value[key] = getPriceBeforeFormatValue(value)
}
function priceFormatter(value: string) {
  let sourceValue = value.replace('￥', '').replace(/,/g, '')
  sourceValue = Number(sourceValue) + ''
  return `${getThousandMoney(sourceValue)}`
}
// 清除金币与千分位格式化
function getPriceBeforeFormatValue(str: string) {
  return str.replace(/￥|,/g, '')
}
// 获取地址展示的文案
function getShowAddress(data: { text: string; detail: string }) {
  return [data.text, data.detail].filter((val) => val).join(' ')
}
// 去往常住地址选择
function checkFormAddress(type: string) {
  addApplyFormKeepAlive()
  const typeData =
    type === permanentAddressLabel
      ? formData.value.permanentAddress
      : formData.value.businessAddress
  if (!typeData) {
    return
  }

  $router.push({
    name: AgriculturalLoanAddressSelectRouteName,
    query: {
      title: type,
      areaText: typeData?.text || '',
      areaValue: (typeData?.value || []).join(','),
      detail: typeData?.detail || '',
    },
  })
}
// 添加套装选配
function addPackagePartInfo() {
  addApplyFormKeepAlive()
  $router.push({
    name: AgriculturalLoanPackageSelectionRouteName,
  })
}
// 编辑套餐选配
function editPackageInfoItem(item: ApplyFormPackageSelectionsItem) {
  addApplyFormKeepAlive()
  $router.push({
    name: AgriculturalLoanPackageSelectionRouteName,
    query: {
      uuid: item.uuid,
      selectionGuid: item.selection_guid,
      relateId: item.product_selection_relate_id,
      num: item.num,
      snNum: item.sns.length,
    },
  })
}
// 删除套装选配
function removePackageInfoItem(data: ApplyFormPackageSelectionsItem) {
  formData.value.packageInfo = formData.value.packageInfo.filter((item) => item.uuid !== data.uuid)
}
// 合约机绑定
async function selectBindDeviceHandle(item: ApplyFormPackageSelectionsItem) {
  // 绑定合约机的物料编码和套餐的产品编码一致，绑定数量和申请购机数量一致
  addApplyFormKeepAlive()
  CurrentPackageSelectionInfoStorage.set(
    formData.value.packageInfo.filter((pageItem) => pageItem.uuid !== item.uuid)
  )
  PackageSelectionCodeMapStorage.set(item.subCodes)
  $router.push({
    name: AgriculturalLoanDeviceListRouteName,
    query: {
      num: item.num,
      code: item.code,
      uuid: item.uuid,
      sns: item.sns.map((item) => item.serial_number).join(','),
    },
  })
}

function checkPowerOfAttorney() {
  addApplyFormKeepAlive()
  $router.push({
    name: AgriculturalLoanPowerOfAttorneyRouteName,
  })
}

function checkAgreement() {
  addApplyFormKeepAlive()
  $router.push({
    name: AgriculturalLoanAgreementRouteName,
  })
}
function verifyPackageInfo() {
  const packageInfo = formData.value.packageInfo
  let bool = true
  packageInfo.forEach((item) => {
    if (item.num !== item.sns.length) {
      bool = false
      item.showWarning = true
    }
  })
  return bool
}
function verifyAgreement() {
  if (!isAgreed.value) {
    showNormalToast('请先阅读并同意授权书再提交申请')
    return false
  }
  return true
}
function confirmHandle() {
  verifyPackageInfo()
  formVm.value?.submit()
}
// 表单检验不通过
function formVerifyFailHandle() {
  showNormalToast('表单信息有误，请完善相关信息后再继续提交')
}
// 确认可提交
async function validateFormSuccessHandle() {
  if (!verifyPackageInfo()) {
    formVerifyFailHandle()
    return
  }
  if (!verifyAgreement()) {
    return
  }
  const params = getSubmitParams()
  const lastSmsCodeInfo = VerifySmsCodeStartTime.get<LastSmsCodeInfoType>()
  if (lastSmsCodeInfo) {
    const lastTime = lastSmsCodeInfo.time
    const lastClientGuid = lastSmsCodeInfo.client_guid
    const lastMessageGuid = lastSmsCodeInfo.message_guid
    if (
      lastTime &&
      Date.now() - lastTime < 60000 &&
      params.client_guid === lastClientGuid &&
      lastMessageGuid
    ) {
      // 60s内发送过且同一个分销商时不再发送,
      verifyCodeVisible.value = true
      return
    }
  }
  showToastLoading()
  try {
    const data = await requestSendVerifyCode(params)
    VerifySmsCodeStartTime.set({
      time: Date.now(),
      client_guid: params.client_guid,
      message_guid: data.message_guid,
    })
    // 发送成功后显示输入的弹窗
    clearToast()
    verifyCodeVisible.value = true
  } catch (error) {
    commonErrorHandle(error)
  }
}

// 写入地址数据
function initAdressInfo() {
  const data = SelectedAddressInfoStorage.get<{
    showAreaValue: string
    title: string
    areaInfo: string[]
    detail: string
  }>()
  const { showAreaValue, title, areaInfo, detail } = data || {}
  if (title && showAreaValue) {
    if (title === permanentAddressLabel) {
      formData.value.permanentAddress.text = showAreaValue
      formData.value.permanentAddress.value = areaInfo
      formData.value.permanentAddress.detail = detail || ''
    } else if (title === businessAddressLabel) {
      formData.value.businessAddress.text = showAreaValue
      formData.value.businessAddress.value = areaInfo
      formData.value.businessAddress.detail = detail || ''
    }
  }
}
// 写入已选机型数据
function initPackageSelectionInfo() {
  const data = ConfirmUsePackageInfoStorage.get<{
    uuid: string
    productName: string
    code: string
    num: number
    standardsProducts: StandardProduct[]
    optionalAccessories: OptionalAccessoriesItem[]
    relateItem: CombinationInfo
  }>()
  if (!data) {
    return
  }
  // formData.value.packageInfo =
  const isAdd = !data.uuid
  const deviceText = data.standardsProducts
    .map((item) => item?.product_info?.name)
    .concat(data.optionalAccessories.map((item) => item.name))
    .filter((val) => val)
    .join('/')
  const selection_guid = data.relateItem?.selection_guid
  const product_selection_relate_id = data.relateItem?.id
  const packageFlag = `${selection_guid}$${product_selection_relate_id}`
  // 若是编辑会有uuid指定到对应的产品
  let matchUuid = data.uuid
  // 判断新增的时候是否已是存在的，是的话累加数量即可
  if (!matchUuid) {
    // 判断是否为同一个套餐信息
    const matchPackage = formData.value.packageInfo.find((item) => {
      return `${item.selection_guid}$${item.product_selection_relate_id}` === packageFlag
    })
    if (matchPackage) {
      matchUuid = matchPackage.uuid
    }
  }
  if (matchUuid) {
    // 修改已有的数据
    const matchItem = formData.value.packageInfo.filter((item) => item.uuid === matchUuid)[0]
    if (matchItem) {
      if (isAdd) {
        matchItem.num = matchItem.num + data.num
      } else {
        matchItem.num = data.num
      }
      matchItem.deviceText = deviceText
    }
  } else {
    formData.value.packageInfo.push({
      uuid: uuidv4(),
      productName: data.productName,
      price: Number(data.relateItem?.product_info?.price44 || 0),
      num: data.num,
      deviceText,
      sns: [],
      selection_guid: data.relateItem?.selection_guid,
      product_selection_relate_id: data.relateItem?.id,
      code: data.code,
      showWarning: false,
      subCodes: (data.relateItem?.sub_products?.map((item) => item.material_code) || []).reduce(
        (result, code) => {
          result[code] = true
          return result
        },
        {} as BooleanObject
      ),
    })
  }
}
// 写入已选绑定设备数据
function initPackageBIndDeviceInfo() {
  const data = ConfirmBindDeviceInfoStorage.get<{
    uuid: string
    mode: string
    list: MyEquipmentItem[]
  }>()
  if (!data) {
    return
  }
  // 确认匹配的套餐项数据
  const currentPackage = formData.value.packageInfo.find((item) => item.uuid === data.uuid)
  if (data.mode === 'add') {
    // 添加未激活设备的时候
    currentPackage.sns.push({
      ...data.list[0],
    })
  } else {
    // 添加缓存中所有的设备
    currentPackage.sns = data.list
  }
}
// 获取相关参数
function getSubmitParams() {
  const formValue = formData.value
  const permanentTexts = formValue.permanentAddress.text.split(' ')
  const businessTexts = formValue.businessAddress.text.split(' ')
  const params: AgriculturalLoanApplyBaseParams = {
    name: formValue.name,
    id_card: formValue.id_card,
    permanent_province: permanentTexts[0] || '',
    permanent_city: permanentTexts[1] || '',
    permanent_district: permanentTexts[2] || '',
    permanent_address: formValue.permanentAddress.detail || '',
    business_province: businessTexts[0] || '',
    business_city: businessTexts[1] || '',
    business_district: businessTexts[2] || '',
    business_address: formValue.businessAddress.detail || '',
    client_guid: formValue.client_guid,
    apply_deadline: formValue.apply_deadline,
    payment_amount: getPriceBeforeFormatValue(formValue.payment_amount),
    apply_loan_amount: getPriceBeforeFormatValue(applyLoanAmount.value),
    family_annual_income: getPriceBeforeFormatValue(formValue.family_annual_income),
    package_selection: formValue.packageInfo.map((item) => {
      return {
        selection_guid: item.selection_guid,
        product_selection_relate_id: item.product_selection_relate_id,
        num: item.num,
        sn: item.sns.map((item) => item.serial_number),
      }
    }),
  }
  return params
}
// 确认提交申请
async function sumbitHandle() {
  const lastSmsCodeInfo = VerifySmsCodeStartTime.get<LastSmsCodeInfoType>()
  if (!lastSmsCodeInfo.message_guid) {
    showNormalToast('请先提交获取验证码')
    return
  }
  try {
    await showConfirmModal({
      title: '提示',
      message: '是否确定申请贷款?',
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      className: 'nongfu-dialog-confirm-class nongfu-dialog-message-center',
    })
  } catch (error) {
    return
  }
  const params = getSubmitParams()
  console.log('params', params)
  showToastLoading()
  try {
    const data = await requestAgriculturaLoanApply({
      ...params,
      code: formData.value.code,
      message_guid: lastSmsCodeInfo.message_guid,
    })
    // 投保成功
    showToastSuccess('申请成功')
    clearToast()
    verifyCodeVisible.value = false
    // 调用app方法，打开农行h5
    AppHost.openNewPage({
      url: `${location.origin}/common-redirect-page?url=${encodeURIComponent(data.jump_url)}`,
      // title: '人脸识别 ',
      showTopBar: true,
    })
    // 清楚列表页缓存，需要重新加载最新的
    removeContractListKeepAlive()
    // 回到列表页面
    $router.go(-1)
  } catch (error) {
    commonErrorHandle(error)
  }
}

onActivated(async () => {
  removeApplyFormAlive()
  initAdressInfo()
  initPackageSelectionInfo()
  initPackageBIndDeviceInfo()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, { title: "新农贷" }),
    _createVNode(_unref(Form), {
      class: "form-wrap nongfu-field-placeholder-wrap",
      ref_key: "formVm",
      ref: formVm,
      onSubmit: validateFormSuccessHandle,
      onFailed: formVerifyFailHandle
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(nameLabel)),
              _createVNode(_unref(Field), {
                modelValue: formData.value.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                placeholder: '请输入' + nameLabel,
                rules: fomrNameRules,
                class: "field-item"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(userIdCardLabel)),
              _createVNode(_unref(Field), {
                modelValue: formData.value.id_card,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.id_card) = $event)),
                placeholder: '请输入' + userIdCardLabel,
                rules: fomrIdCardRules,
                class: "field-item"
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(permanentAddressLabel)),
              _createVNode(_unref(Field), {
                class: "field-item",
                modelValue: formData.value.permanentAddress.text,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.permanentAddress.text) = $event)),
                rules: formPermanentAddressRules
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "cell-arrow-right",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (checkFormAddress(permanentAddressLabel)))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text xag-ellipsis", formData.value?.permanentAddress?.text ? '' : 'placehoder-color'])
                    }, _toDisplayString(getShowAddress(formData.value?.permanentAddress) || `请选择${permanentAddressLabel}`), 3)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(businessAddressLabel)),
              _createVNode(_unref(Field), {
                class: "field-item",
                modelValue: formData.value.businessAddress.text,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.businessAddress.text) = $event)),
                rules: formBusinessAddressRules
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "cell-arrow-right",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (checkFormAddress(businessAddressLabel)))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text xag-ellipsis", formData.value?.businessAddress?.text ? '' : 'placehoder-color'])
                    }, _toDisplayString(getShowAddress(formData.value?.businessAddress) || `请选择${businessAddressLabel}`), 3)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _hoisted_8
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", {
              class: "add-parts",
              onClick: addPackagePartInfo
            }, [
              _createVNode(_unref(Icon), {
                name: "add-o",
                class: "icon-add"
              }),
              _createTextVNode(" 添加套装选配 ")
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: _normalizeClass(["package-info", formData.value.packageInfo?.length ? '' : 'empty-wrap'])
            }, [
              (formData.value.packageInfo?.length)
                ? (_openBlock(), _createBlock(PackageProductInfo, {
                    key: 0,
                    list: formData.value.packageInfo,
                    onRemove: removePackageInfoItem,
                    onSelectBindDevice: selectBindDeviceHandle,
                    onEdit: editPackageInfoItem
                  }, null, 8, ["list"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无套餐选配内容"))
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(jifeiDistributorLabel)),
              _createElementVNode("div", {
                class: "cell-arrow-right",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (distributorSelectPopupVisible.value = true))
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text xag-ellipsis", formData.value?.clientText ? '' : 'placehoder-color'])
                }, _toDisplayString(formData.value?.clientText || `请选择${jifeiDistributorLabel}`), 3)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(applyLimitTimeLabel)),
              _createVNode(_unref(Field), {
                modelValue: formData.value.apply_deadline,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.apply_deadline) = $event)),
                rules: fomrApplyLimitTimeRules,
                class: "field-item"
              }, {
                input: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "cell-arrow-right",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (limitTimePopupVisible.value = true))
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["text xag-ellipsis", formData.value?.apply_deadline ? '' : 'placehoder-color'])
                    }, _toDisplayString(formData.value?.apply_deadline || `请选择${applyLimitTimeLabel}`), 3)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", { class: "label" }, _toDisplayString(buyProductPriceLabel)),
              _createVNode(_unref(Field), {
                formatter: priceFormatter,
                readonly: "",
                modelValue: _unref(buyProductTotalPriceFormat),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(buyProductTotalPriceFormat) ? (buyProductTotalPriceFormat).value = $event : null)),
                class: "field-item"
              }, {
                "left-icon": _withCtx(() => [
                  _createTextVNode("￥")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", { class: "label" }, _toDisplayString(payedOffDownPaymentLabel)),
              _createVNode(_unref(Field), {
                class: "field-item",
                rules: fomrPayedOffDownPaymentRules
              }, {
                input: _withCtx(() => [
                  _createVNode(_unref(RadioGroup), {
                    modelValue: formData.value.isPayedOffDownPayment,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.isPayedOffDownPayment) = $event)),
                    "checked-color": "#00C378",
                    class: "radio-group xa-radio-group"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Radio), { name: "1" }, {
                        default: _withCtx(() => [
                          _createTextVNode("否")
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Radio), { name: "2" }, {
                        default: _withCtx(() => [
                          _createTextVNode("是")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            (formData.value.isPayedOffDownPayment === '2')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", { class: "label-wrap" }, [
                    _createElementVNode("div", {
                      class: "label",
                      required: ""
                    }, _toDisplayString(payedOffDownPaymentPriceLabel)),
                    _createElementVNode("div", { class: "tips" }, _toDisplayString(payedoffDownProcessTips))
                  ]),
                  _createVNode(_unref(Field), {
                    modelValue: formData.value.payment_amount,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.payment_amount) = $event)),
                    class: "field-item",
                    onBlur: _cache[12] || (_cache[12] = ($event: any) => (priceBlurFormatterHandle('payment_amount'))),
                    onFocus: _cache[13] || (_cache[13] = ($event: any) => (priceFocusFormatterHandle('payment_amount'))),
                    placeholder: `请输入${payedOffDownPaymentPriceLabel}`,
                    rules: formPayedOffDownPaymentPriceRules
                  }, {
                    "left-icon": _withCtx(() => [
                      _createTextVNode("￥")
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(annualHouseholdIncomeLabel)),
              _createVNode(_unref(Field), {
                modelValue: formData.value.family_annual_income,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.family_annual_income) = $event)),
                class: "field-item",
                onBlur: _cache[15] || (_cache[15] = ($event: any) => (priceBlurFormatterHandle('family_annual_income'))),
                onFocus: _cache[16] || (_cache[16] = ($event: any) => (priceFocusFormatterHandle('family_annual_income'))),
                placeholder: `请输入${annualHouseholdIncomeLabel}`,
                rules: formAnnualHouseholdIncomePriceRules
              }, {
                "left-icon": _withCtx(() => [
                  _createTextVNode("￥")
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", {
                class: "label",
                required: ""
              }, _toDisplayString(applyPriceLabel)),
              _createVNode(_unref(Field), {
                readonly: "",
                modelValue: _unref(applyLoanAmount),
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(applyLoanAmount) ? (applyLoanAmount).value = $event : null)),
                class: "field-item"
              }, {
                "left-icon": _withCtx(() => [
                  _createTextVNode("￥")
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(CommonFooterNextButton, {
      title: "提交申请",
      onClick: confirmHandle
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", {
          class: "agree-agreement",
          onClick: _cache[18] || (_cache[18] = ($event: any) => (isAgreed.value = !isAgreed.value))
        }, [
          _createVNode(_unref(Icon), {
            name: "passed",
            class: _normalizeClass(isAgreed.value ? 'name-color' : '')
          }, null, 8, ["class"]),
          _createElementVNode("div", _hoisted_24, [
            _createTextVNode(" 我已经阅读并同意 "),
            _createElementVNode("span", {
              class: "name-color",
              onClick: _withModifiers(checkPowerOfAttorney, ["stop"])
            }, "《授权书》", 8, _hoisted_25)
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(LimitTimeSelect, {
      visible: limitTimePopupVisible.value,
      "onUpdate:visible": _cache[19] || (_cache[19] = ($event: any) => ((limitTimePopupVisible).value = $event)),
      activeKey: formData.value.apply_deadline,
      "onUpdate:activeKey": _cache[20] || (_cache[20] = ($event: any) => ((formData.value.apply_deadline) = $event))
    }, null, 8, ["visible", "activeKey"]),
    _createVNode(DistributorSelect, {
      visible: distributorSelectPopupVisible.value,
      "onUpdate:visible": _cache[21] || (_cache[21] = ($event: any) => ((distributorSelectPopupVisible).value = $event)),
      "active-text": formData.value.clientText,
      "onUpdate:active-text": _cache[22] || (_cache[22] = ($event: any) => ((formData.value.clientText) = $event)),
      "active-key": formData.value.client_guid,
      "onUpdate:active-key": _cache[23] || (_cache[23] = ($event: any) => ((formData.value.client_guid) = $event))
    }, null, 8, ["visible", "active-text", "active-key"]),
    _createVNode(DistributorVerifyCode, {
      code: formData.value.code,
      "onUpdate:code": _cache[24] || (_cache[24] = ($event: any) => ((formData.value.code) = $event)),
      visible: verifyCodeVisible.value,
      "onUpdate:visible": _cache[25] || (_cache[25] = ($event: any) => ((verifyCodeVisible).value = $event)),
      onConfirm: sumbitHandle
    }, null, 8, ["code", "visible"])
  ], 64))
}
}

})